
































import { Component, Prop, Vue, Watch, Emit } from 'vue-property-decorator';
import showdown from 'showdown';

const mdConverter = new showdown.Converter({
  openLinksInNewWindow: true,
  tables: true,
});

@Component
export default class Home extends Vue {

  @Prop() private theme!: string;
  @Prop({ default: '' }) private markdown!: string;
  @Prop({ default: 'normal' }) private fontSize!: string;

  private get markdownHtml() {
    return mdConverter.makeHtml(this.markdown);
  }

  private get viewerTheme() {
    return `theme-${this.$props.theme}`;
  }

  private get fontSizeClass() {
    return `font-size-${this.$props.fontSize}`;
  }

  private get isWindows() {
    return window.Windows !== undefined;
  }

  private openFile() {
    this.$emit('open-file');
  }
}
